import enumBase from './EnumBase';

export default class BulkSendStatus extends enumBase {
  static CREATED = 'created';
  static PROCESSING = 'processing';
  static COMPLETED = 'completed';
  static FAILED = 'failed';
  static CANCELLED = 'cancelled';

  static DRAFT = 'draft';
  static DISPATCHED = 'dispatched';
  static AWAITING_SIGNATURE = 'awaitingSignature';

  static values = [
    this.CREATED,
    this.PROCESSING,
    this.COMPLETED,
    this.FAILED,
    this.CANCELLED,
  ];

  static icons = {
    [this.CREATED]: { name: 'file-circle-plus', class: 'icon--dark-blue' },
    [this.DRAFT]: { name: 'file-pen', class: 'icon--faded' },
    [this.PROCESSING]: { name: 'clock', class: 'icon--pending' },
    [this.COMPLETED]: { name: 'circle-check', class: 'icon--finished' },
    [this.FAILED]: { name: 'triangle-exclamation', class: 'icon--canceled' },
    [this.CANCELLED]: { name: 'ban', class: 'icon--canceled' },
    [this.DISPATCHED]: { name: 'paper-plane', class: 'icon--pending' },
    [this.AWAITING_SIGNATURE]: { name: 'clock', class: 'icon--pending' },
  };

  static getAllStatusTranslated(i18n) {
    return this.values.map((item) => ({
      value: item,
      label: i18n.t(`bulkSendsCardTable.statuses.${item}`) || item,
    }));
  }

  static getIcon(value) {
    return this.icons[value] || this.icons[this.CREATED];
  }

  static getText(value, i18n) {
    return i18n.t(`bulkSendsCardTable.statuses.${value}`) || value;
  }

  static isBeforeSentStatus(value) {
    return Boolean(
      value !== this.COMPLETED &&
        value !== this.CANCELLED &&
        value !== this.FAILED &&
        value !== this.CANCELLED
    );
  }
}
